require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-animate/index.js
// module id = 497
// module chunks = 2